import { render, staticRenderFns } from "./QuestionAnswerItemParticipant.vue?vue&type=template&id=083b146f&"
import script from "./QuestionAnswerItemParticipant.vue?vue&type=script&lang=js&"
export * from "./QuestionAnswerItemParticipant.vue?vue&type=script&lang=js&"
import style0 from "./QuestionAnswerItemParticipant.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* nuxt-component-imports */
installComponents(component, {QuestionAnswerForm: require('/lasso/components/questions/QuestionAnswerForm.vue').default,QuestionAnswerHistory: require('/lasso/components/questions/QuestionAnswerHistory.vue').default})


/* hot reload */
if (module.hot) {
  var api = require("/lasso/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('083b146f')) {
      api.createRecord('083b146f', component.options)
    } else {
      api.reload('083b146f', component.options)
    }
    module.hot.accept("./QuestionAnswerItemParticipant.vue?vue&type=template&id=083b146f&", function () {
      api.rerender('083b146f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/questions/QuestionAnswerItemParticipant.vue"
export default component.exports